import { Button } from "@mui/material";
import styles from "./styles.module.css";
import ExcelJS from "exceljs";

const ExportExcelButton = (props) => {
  const {
    data,
    filename,
    buttonLabel = "Download Excel",
    retrieveData,
    retrieveCabecalho,
    ...fields
  } = props;

  const exportToExcel = async () => {
    let exportData = data;
    let exportFilename = filename;

    if (retrieveData) {
      const [lateData, lateFilename] = await retrieveData();
      exportData = lateData;
      exportFilename = lateFilename;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    let startingDataRow = 1;

    if (retrieveCabecalho) {
      startingDataRow = await retrieveCabecalho(worksheet);
    }

    const headers = Object.keys(exportData[0]);
    headers.forEach((header, index) => {
      worksheet.getCell(startingDataRow, index + 1).value = header;
    });

    exportData.forEach((dataRow, rowIndex) => {
      const row = worksheet.getRow(rowIndex + startingDataRow + 1);
      headers.forEach((header, colIndex) => {
        row.getCell(colIndex + 1).value = dataRow[header];
      });
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber >= startingDataRow) {
        let isBoldRow = false;
        row.eachCell((cell) => {
          let cellValue = cell.value.toString();

          // Regular expression for the unified <style> tag
          const styleRegex = /<style\s*(.*?)>(.*?)<\/style>/g;
          const styleMatch = styleRegex.exec(cellValue);

          if (styleMatch) {
            const styleAttributes = styleMatch[1];
            const text = styleMatch[2];

            let font = {
              name: "SansSerif",
              size: 9,
              bold: false,
              italic: false,
              color: { argb: "000000" },
            };
            let alignment = { vertical: "top", horizontal: "left" };

            let isDate = false;
            let isNumber = false;

            const attributes = styleAttributes.split(" ");
            attributes.forEach((attr) => {
              if (attr === "bold") {
                font.bold = true;
                isBoldRow = true;
              } else if (attr === "italic") {
                font.italic = true;
              } else if (attr.startsWith("size=")) {
                font.size = parseInt(attr.split("=")[1], 10);
              } else if (attr.startsWith("color=")) {
                font.color = { argb: attr.split("=")[1].replace("#", "") };
              } else if (attr.startsWith("valign=")) {
                alignment.vertical = attr.split("=");
              } else if (attr.startsWith("halign=")) {
                alignment.horizontal = attr.split("=");
              } else if (attr.startsWith("numFmt=")) {
                const numFmtArr = attr.split("=")[1];

                const numFmtType = numFmtArr.split(":")[0];
                const numFmtVar = numFmtArr.split(":")[1];

                if (numFmtType === "date") {
                  isDate = true;
                } else if (numFmtType === "number") {
                  isNumber = true;
                }

                cell.numFmt = numFmtVar;
              }
            });

            cell.font = font;
            cell.alignment = alignment;

            if (isDate) {
              cell.value = new Date(text);
            } else if (isNumber) {
              cell.value = Number(text);
            } else {
              cell.value = text;
            }
          } else {
            cell.font = { name: "SansSerif", size: 9 };
            cell.alignment = { vertical: "top", horizontal: "left" };
          }
        });
        if (isBoldRow) {
          row.height = (row.height || 15) * 1.5;
        }
      }
    });

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.row >= startingDataRow) {
          const cellValue = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, cellValue.length);
        }
      });
      column.width = maxLength + 2;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${exportFilename}.xlsx`;
      link.click();
    });
  };

  return (
    <Button
      className={styles.botaoNovo}
      onClick={exportToExcel}
      size="small"
      {...fields}
    >
      {buttonLabel}
    </Button>
  );
};

export default ExportExcelButton;
